var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlex1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 47,
    viewBox: "0 0 98 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_435)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 98,
    height: 46
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.7863 0H0V45.4361H97.7863V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_435)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_435",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 98,
    height: 46
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7863 0H0V45.0195H97.7863V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0554 8.05142C12.1572 8.05142 9.64652 9.17342 7.53221 11.8134V8.90941H0V44.6807C0 44.6807 0.132143 44.7467 0.528575 44.8127C1.05715 44.9447 3.83216 45.5387 5.88039 43.8228C7.66432 42.3047 8.06077 40.5228 8.06077 38.5428V33.3949C10.2412 35.7049 12.6858 36.6949 16.1216 36.6949C23.5216 36.6949 29.2037 30.689 29.2037 22.7032C29.2037 14.0572 23.7197 8.05142 16.0554 8.05142ZM14.6019 29.8971C10.4393 29.8971 7.13574 26.465 7.13574 22.3072C7.13574 18.2152 11.034 14.9154 14.6019 14.9154C18.8304 14.9154 22.068 18.1492 22.068 22.3731C22.068 26.597 18.7643 29.8971 14.6019 29.8971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9073 21.8455C39.9073 24.9474 40.2376 28.7092 43.2769 32.8012C43.343 32.8671 43.4751 33.065 43.4751 33.065C42.2197 35.1771 40.7001 36.6291 38.6519 36.6291C37.0661 36.6291 35.4804 35.7711 34.1589 34.3191C32.7715 32.7352 32.1108 30.6891 32.1108 28.5113V-0.00012207H39.8413L39.9073 21.8455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8988 22.3732L68.7808 8.90952H78.1635L87.2151 22.3732L78.1635 35.7709H68.7808L77.8988 22.3732Z",
    fill: "#EBAF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6588 20.8553L97.7856 8.90952H88.4036L85.0342 13.8594L89.6588 20.8553Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0342 30.887L86.6194 33.065C88.1395 35.441 90.1217 36.629 92.434 36.629C94.8786 36.563 96.5963 34.451 97.2575 33.6591C97.2575 33.6591 96.0681 32.603 94.5481 30.821C92.4999 28.4451 89.7912 24.0892 89.7253 23.8912L85.0342 30.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.844 28.049C60.2583 29.501 59.2011 30.2929 57.0207 30.2929C53.1225 30.2929 50.8761 27.521 50.5457 24.485H71.2263C71.358 24.0891 71.4246 23.5611 71.4246 22.7032C71.4246 14.3212 65.2797 8.05142 57.2189 8.05142C49.5546 8.05142 43.2778 14.4533 43.2778 22.4392C43.2778 30.359 49.5546 36.6288 57.4172 36.6288C62.9012 36.6288 67.6582 33.5269 70.2351 28.049H61.844ZM57.285 14.3873C60.7207 14.3873 63.2976 16.6312 63.8922 19.6011H50.81C51.4706 16.4992 53.9153 14.3873 57.285 14.3873Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97.7863,
    height: 46.0992,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlex1);
export default __webpack_public_path__ + "static/media/plex-1.07f25c44318c336f5c9e04b49ea6bee7.svg";
export { ForwardRef as ReactComponent };